import { Nullable, Profile, Project } from '@brg/api';
import { bProfile, ProfileRole } from '@brg/auth';
import { VISUAL_RES_TAG_ID_BL } from 'shared/constants/misc';
import { IProjectLight } from 'shared/common';
import { HsePolicies } from 'shared/constants/HsePolicies';


export class ProjectDelegate {
    /**
     * Возвращает true, если пользователь может редактировать проект
     * @param user
     * @param project
     *
     * +---------+
     * |  Нурс   |
     * +---------+
     */
    public static isProjectEditableFor(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project) {
            return false
        }

        const userId = user.accountId;
        const authors = [project.authorId].concat(project.coAuthorIds);
        const curators = project.curatorsIdList ?? [];

        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isMiddleModer = bProfile.hasRole(user, ProfileRole.middlemoder);
        const canProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_project)).containsIn(user.rolesList);
        const isLMS = project?.contexts?.includes('lmshseproject') || project?.contexts?.includes('lmsproject');  
        const canLmsProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.lms_admin)).containsIn(user.rolesList);
        const hasEditByTagCategoryPolicy =  user.rolesList && Array.isArray(user.rolesList)
            && user.rolesList.some((x: string) => x.startsWith(HsePolicies.can_edit_project_by_tag_category_prefix));

        if (authors.includes(userId) && project.status === 6) {
            return false;
        }

        if (authors.includes(userId) || curators.includes(userId)) {
            return true
        }

        //BURG-1605 - Отключить возможность редактировать чужие проекты модератору и эксперту тегов.
        // //@ts-ignore
        // if (user.tagListId?.some(x => project?.tagsID?.includes(x))) {
        //     return true;
        // }

        // //@ts-ignore
        // if (user.tagListId_Expert?.some(x => project?.tagsID?.includes(x))) {
        //     return true;
        // }

        if (hasEditByTagCategoryPolicy) {
            const tagsCategory = user.rolesList
                .filter(x => x.startsWith(HsePolicies.can_edit_project_by_tag_category_prefix))
                .map(x => x.replace(HsePolicies.can_edit_project_by_tag_category_prefix, ''));

    // @ts-ignore
            if (project?.tags?.some(t => tagsCategory.some(x => t["groupIds"]?.includes(x)))) {
                return true;
            }
        }

        return isModer || isMiddleModer || canProjectEdit || (isLMS && canLmsProjectEdit);
    }

    /**
     * Если возвращает true, отображается панель с правками проекта
     * @param user
     * @param project
     */
    public static shouldDisplayProjectToolsFor(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project || project.book) {
            return false
        }

        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isMiddleModer = bProfile.hasRole(user, ProfileRole.middlemoder);
        const isTeacher = bProfile.isEmployee(user);
        const isContextModer = user?.rolesList?.some((role) => role?.includes('moder'));
        const isContextMiddleModer = user?.rolesList?.some((role) => role?.includes('middlemoder'));
 
        const canProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_project)).containsIn(user.rolesList);

        return isModer || isTeacher || isContextModer || isMiddleModer || isContextMiddleModer || canProjectEdit;
    }

    public static makeProjectToCompetitionsVS(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project) {
            return false
        }

        const isVSproject = project?.tagsID?.includes(VISUAL_RES_TAG_ID_BL);
        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isVSModer = user?.rolesList?.includes('hsevisualresearchmoder');
        const isPublishedProject = project?.status === 1 || project?.status === 6;

        const canMakeProjectToCompetition = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.allow_send_project_to_competition)).containsIn(user.rolesList);

        // return isModer && isVSModer && isContextModer;
        return (isVSModer || canMakeProjectToCompetition) && isPublishedProject;
    }

    public static isRejectedProject(project: Nullable<Project | Project<'Global'> | IProjectLight >) {
        if (!project) {
            return false;
        }

        return project?.status === 3
    }

    public static canEditShowcaseProjects(user: Nullable<Profile>) {
        if (!user) {
            return false
        }

        return true;

        // const isModer = bProfile.hasRole(user, ProfileRole.moder);
        // const isTeacher = bProfile.isEmployee(user);
        //
        // return isModer || isTeacher;
    }
}
import { Nullable, Profile, Project } from '@brg/api';
import { bProfile, ProfileRole } from '@brg/auth';
import { VISUAL_RES_TAG_ID_BL } from 'shared/constants/misc';
import { IProjectLight } from 'shared/common';
import { HsePolicies } from 'shared/constants/HsePolicies';


export class ProjectDelegate {
    /**
     * Возвращает true, если пользователь может редактировать проект
     * @param user
     * @param project
     *
     * +---------+
     * |  Нурс   |
     * +---------+
     */
    public static isProjectEditableFor(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project) {
            return false
        }

        const userId = user.accountId;
        const authors = [project.authorId].concat(project.coAuthorIds);
        const curators = project.curatorsIdList ?? [];

        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isMiddleModer = bProfile.hasRole(user, ProfileRole.middlemoder);
        const canProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_project)).containsIn(user.rolesList);
        const isLMS = project?.contexts?.includes('lmshseproject') || project?.contexts?.includes('lmsproject');  
        const canLmsProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.lms_admin)).containsIn(user.rolesList);
        const hasEditByTagCategoryPolicy =  user.rolesList && Array.isArray(user.rolesList)
            && user.rolesList.some((x: string) => x.startsWith(HsePolicies.can_edit_project_by_tag_category_prefix));

        if (authors.includes(userId) && project.status === 6) {
            return false;
        }

        if (authors.includes(userId) || curators.includes(userId)) {
            return true
        }

        //BURG-1605 - Отключить возможность редактировать чужие проекты модератору и эксперту тегов.
        // //@ts-ignore
        // if (user.tagListId?.some(x => project?.tagsID?.includes(x))) {
        //     return true;
        // }

        // //@ts-ignore
        // if (user.tagListId_Expert?.some(x => project?.tagsID?.includes(x))) {
        //     return true;
        // }

        if (hasEditByTagCategoryPolicy) {
            const tagsCategory = user.rolesList
                .filter(x => x.startsWith(HsePolicies.can_edit_project_by_tag_category_prefix))
                .map(x => x.replace(HsePolicies.can_edit_project_by_tag_category_prefix, ''));

    // @ts-ignore
            if (project?.tags?.some(t => tagsCategory.some(x => t["groupIds"]?.includes(x)))) {
                return true;
            }
        }

        return isModer || isMiddleModer || canProjectEdit || (isLMS && canLmsProjectEdit);
    }

    /**
     * Если возвращает true, отображается панель с правками проекта
     * @param user
     * @param project
     */
    public static shouldDisplayProjectToolsFor(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project || project.book) {
            return false
        }

        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isMiddleModer = bProfile.hasRole(user, ProfileRole.middlemoder);
        const isTeacher = bProfile.isEmployee(user);
        const isContextModer = user?.rolesList?.some((role) => role?.includes('moder'));
        const isContextMiddleModer = user?.rolesList?.some((role) => role?.includes('middlemoder'));
 
        const canProjectEdit = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_project)).containsIn(user.rolesList);

        return isModer || isTeacher || isContextModer || isMiddleModer || isContextMiddleModer || canProjectEdit;
    }

    public static makeProjectToCompetitionsVS(user: Nullable<Profile>, project: Nullable<Project | Project<'Global'>>) {
        if (!user || !project) {
            return false
        }

        const isVSproject = project?.tagsID?.includes(VISUAL_RES_TAG_ID_BL);
        const isModer = bProfile.hasRole(user, ProfileRole.moder);
        const isVSModer = user?.rolesList?.includes('hsevisualresearchmoder');
        const isPublishedProject = project?.status === 1 || project?.status === 6;

        const canMakeProjectToCompetition = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.allow_send_project_to_competition)).containsIn(user.rolesList);

        // return isModer && isVSModer && isContextModer;
        return (isVSModer || canMakeProjectToCompetition) && isPublishedProject;
    }

    public static isRejectedProject(project: Nullable<Project | Project<'Global'> | IProjectLight >) {
        if (!project) {
            return false;
        }

        return project?.status === 3
    }

    public static canEditShowcaseProjects(user: Nullable<Profile>) {
        if (!user) {
            return false
        }

        return true;

        // const isModer = bProfile.hasRole(user, ProfileRole.moder);
        // const isTeacher = bProfile.isEmployee(user);
        //
        // return isModer || isTeacher;
    }
}
